var flagMapper = {
	1:"success",
	2:"warning",
	3:"error"
};

function toastNotify(messageFlag, messageContent) {
	var messageType = flagMapper[messageFlag];
    
    var toastNotif = document.querySelector(".toast-notification-container");    
    toastNotif.classList.add(messageType)
    toastNotif.querySelector(".notification-icon").classList.add(messageType)
    toastNotif.classList.add("show");
    toastNotif.querySelector(".notification-message p").innerHTML = messageContent;

	setTimeout(closeToastNotification,3000);
}

function closeToastNotification() {    
    var toastNotif = document.querySelector(".toast-notification-container");
    toastNotif.setAttribute("class", "toast-notification-container");
}

export default toastNotify;